import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import dayjs from 'dayjs';
import React, { useState, useMemo } from 'react';
import { CSVLink } from 'react-csv';
import { RiSave3Line } from 'react-icons/ri';
import { useSelector } from 'react-redux';

import styles from './index.module.scss';
import Table from './Table';

import Spinner from '@/components/ui/Spinner';
import API from '@/helpers/API';

const cx = classNames.bind(styles);

const Main = () => {
  const query = useSelector((state) => state.query);
  const [isLoading, setLoading] = useState(false);
  const [telemetries, setTelemetries] = useState({});

  const data = useMemo(() => {
    return telemetries[query.targetMessage?.msgId] ?? [];
  }, [query.targetMessage, telemetries]);

  useUpdateEffect(() => {
    if (!query.targetMessage) {
      setTelemetries({});
      return;
    }

    const { msgId } = query.targetMessage;
    // 텔레메트리 메시지 존재 시
    if (telemetries[msgId]) return;

    const params = {
      from: dayjs(query.fromDate + query.fromTime)
        .utc()
        .format(),
      to: dayjs(query.toDate + query.toTime)
        .utc()
        .format(),
    };

    setLoading(true);

    API.get(`/robots/${query.robotId}/telemetries/${msgId}`, { params })
      .then(({ success, data }) => {
        if (success) {
          setTelemetries({
            ...telemetries,
            [msgId]: data,
          });
        }
      })
      .finally(() => setLoading(false));
  }, [query.targetMessage]);

  const filename = useMemo(() => {
    if (!query.targetMessage) return;

    return `${query.targetMessage.msgName}_${query.fromDate}_${query.fromTime}-${query.toTime}.csv`;
  }, [query]);

  // 로딩 완료 시
  return (
    <div className={cx('container')}>
      {isLoading && (
        <div className={cx('spinnerWrapper')}>
          <Spinner />
        </div>
      )}
      {!isLoading && query.targetMessage && (
        <div className={cx('header')}>
          <div className={cx('title')}>
            {query.targetMessage.msgName} ({query.targetMessage.msgId})
          </div>
          {data.length > 0 && (
            <CSVLink filename={filename} data={data} className={cx('button')}>
              <RiSave3Line size={16} color="white" />
            </CSVLink>
          )}
        </div>
      )}
      <Table data={data} />
    </div>
  );
};

export default Main;
